import { useEffect, useState } from "react";
import { IAudiencia } from "../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import { useLocation } from "react-router-dom";
import { GetsAudienciaController } from "../../../Controllers/Automacao/Audiencia/AudienciaControllers";

export function useGestaoAudiencia() {
    const [lstAudiencia, setLstAudiencia] = useState<Array<IAudiencia>>();
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);
    const location = useLocation();

    useEffect(() => {
        updateList();
    }, [setLstAudiencia]);

    function updateList() {
        GetsAudienciaController().then((res) => {
            setLstAudiencia(res);
        });
    }
    return {
        updateList,
        location,
        show,
        setShow,
        modal,
        setModal,
        lstAudiencia,
    };
}
